// Client-side store for the kiosk-scoped session token. The token is
// issued by `kiosk/pair` once the device is claimed; subsequent
// `kiosk/*` calls authenticate with `Authorization: Bearer <token>`.
// The legacy `x-kiosk-id` header is gone — the wrapper resolves the
// kiosk identity from the session row.
//
// Stored in localStorage (not sessionStorage like portalSession /
// requestSession): a kiosk is a long-lived device pairing, and the
// backend issues these tokens with a 90-day TTL. sessionStorage was
// dropping the token every browser/tab close, forcing staff to
// re-pair daily. The kiosk-id is already in localStorage on the same
// origin; keeping the session token alongside it matches that
// lifetime. The token still expires server-side — `isLikelyValid`
// honors `expiresAt` — and `clear()` removes both keys on explicit
// unpair.

const TOKEN_KEY = 'healthcom-schedule.kioskSession.token';
const EXPIRES_KEY = 'healthcom-schedule.kioskSession.expiresAt';

export const kioskSession = {
  getToken(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },

  setToken(token: string, expiresAt?: string) {
    try {
      localStorage.setItem(TOKEN_KEY, token);
      if (expiresAt) localStorage.setItem(EXPIRES_KEY, expiresAt);
    } catch {
      /* storage blocked */
    }
  },

  clear() {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(EXPIRES_KEY);
    } catch {
      /* ignore */
    }
  },

  isLikelyValid(): boolean {
    const token = this.getToken();

    if (!token) return false;

    let expiresAt: string | null = null;

    try {
      expiresAt = localStorage.getItem(EXPIRES_KEY);
    } catch {
      return true;
    }

    if (!expiresAt) return true;

    const expiresAtMs = Date.parse(expiresAt);

    return Number.isFinite(expiresAtMs) && expiresAtMs > Date.now();
  },
};
